import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './HasOpenPriceCheckbox.module.scss';

interface IProps {
	toggleHasOpenPrice: () => void;
	hasOpenPrice: boolean;
	isDisabled: boolean;
}

export const HasOpenPriceCheckbox: React.FC<IProps> = React.memo(({ toggleHasOpenPrice, hasOpenPrice, isDisabled }) => {
	return (
		<Form.Item className={style.container} name="hasOpenPrice" data-test="HasOpenPriceCheckbox">
			<Checkbox onChange={toggleHasOpenPrice} checked={hasOpenPrice} disabled={isDisabled}>
				<Text translationNameSpace="form" translationKey="hasOpenPricePercentLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
